import { styled } from "@mui/system";
import { TableRow, TableCell } from "@mui/material";

export const getStockCoverageColor = (value, type) => {
    if (value === "-") return "#FFFFFF";

    if (value === "" || value === " ") {
        return "#f5f5f5";
    }
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return "#FFFFFF";
    if (type === 'Norm Alert') {
        if (numericValue >= 0 && numericValue <= 50) return "#FF9998";
        if (numericValue > 50 && numericValue <= 74) return "#FFEC9A";
        if (numericValue > 74 && numericValue <= 100) return "#A3E1D2";
        if (numericValue > 100) return "#80cbc4";
    } else if (type === 'Weekly OR') {
        if (numericValue >= 0 && numericValue <= 80) return "#FF9998";
        if (numericValue > 80 && numericValue <= 89) return "#FFEC9A";
        if (numericValue > 89 && numericValue <= 100) return "#A3E1D2";
    } else if (type === 'RMPM Alert' || type === 'MAI % (Physical)') {
        if (numericValue >= 0 && numericValue < 75) return "#feb0af";
        if (numericValue >= 75 && numericValue < 90) return "#FFF9C4";
        if (numericValue >= 90 && numericValue < 125) return "#A3E1D2";
        if (numericValue >= 125) return "#2196f33d";
    }
    else if (type === 'FG Coverage' || type === 'Physical FG Coverage') {
        if (numericValue >= 0 && numericValue <= 60) return "#FF9998";
        if (numericValue > 60 && numericValue <= 80) return "#FFEC9A";
        if (numericValue > 80 && numericValue <= 100) return "#A3E1D2";
    } else if (type === 'Not Required') {
        return "#FFFFFF";
    } else {
        if (numericValue >= 0 && numericValue <= 40) return "#FF9998";
        if (numericValue > 40 && numericValue <= 75) return "#FFEC9A";
        if (numericValue > 75 && numericValue <= 100) return "#A3E1D2";
    }
    return "#FFFFFF";
};

export const StyledTableCell = styled(TableCell)(({ stockcoverage, type }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "var(--primany-table-header-color)",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
        backgroundColor: stockcoverage ? getStockCoverageColor(stockcoverage, type) : "#FFFFFF",
    },
}));

export const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

export const StyledTableSubHeaderCell = styled(TableCell)(({ stockcoverage, type }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: stockcoverage ? getStockCoverageColor(stockcoverage, type) : "#F5F5F5",
        color: "var(--black-color)",
        textAlign: "center",
        padding: "2px",
        fontSize: "12px",
        fontWeight: 600,
        outline: "1px solid #DBDBDB",
        borderBottom: "none",
        whiteSpace: "nowrap",
    },
}));

export const StyledLeftEmptyCell = {
    backgroundColor: "#FFFFFF !important",
    outline: "none !important",
    borderLeft: "1px solid #EAECF0 !important",
    borderBottom: "1px solid #EAECF0 !important"
};

export const StyledEmptyCell = {
    backgroundColor: "#FFFFFF !important",
    outline: "none !important",
    borderBottom: "1px solid #EAECF0 !important"
};

export const cellStyles = {
    leftEmpty: {
        backgroundColor: "#FFFFFF !important",
        outline: "none !important",
        borderLeft: "1px solid #EAECF0 !important",
        borderBottom: "1px solid #EAECF0 !important"
    },
    empty: {
        backgroundColor: "#FFFFFF !important",
        outline: "none !important",
        borderBottom: "1px solid #EAECF0 !important"
    }
};

export const StyledTableSubHeaderCovPlanCell = styled(TableCell)({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#F5F5F5",
        color: "var(--black-color)",
        textAlign: "center",
        padding: "2px",
        fontSize: "12px",
        fontWeight: 600,
        outline: "1px solid #DBDBDB",
        borderBottom: "none",
        whiteSpace: "nowrap",
    },
});